import { get, post, destroy, put } from "./api";

export const getDistributionLists = async () => {
    return await get('api/DistributionLists');
}

export const getDistributionList = async (id) => {
    return await get(`api/DistributionLists/${id}`);
}

export const getDistributionListAlternatives = async (id) => {
    return await get(`api/DistributionLists/${id}/alternatives`);
}

export const createDistributionList = async (name) => {
    return await post('api/DistributionLists', { name });
}

export const createDistributionListAlternative = async (id, request) => {
    return await post(`api/DistributionLists/${id}/alternatives`, request);
}

export const updateDistributionList = async (request) => {
    return await put(`api/DistributionLists`, request);
}

export const updateDistributionListAlternative = async (id, request) => {
    return await put(`api/DistributionLists/${id}/alternatives`, request);
}

export const enableDistributionList = async (id) => {
    return await put(`api/DistributionLists/${id}/enable`);
}

export const disableDistributionList = async (id) => {
    return await put(`api/DistributionLists/${id}/disable`);
}

export const enableDistributionListAlternative = async (id, distributionListAlternativeId) => {
    return await put(`api/DistributionLists/${id}/alternatives/${distributionListAlternativeId}/enable`, {});
}

export const disableDistributionListAlternative = async (id, distributionListAlternativeId) => {
    return await put(`api/DistributionLists/${id}/alternatives/${distributionListAlternativeId}/disable`, {});
}

export const deleteDistributionList = async (id) => {
    return await destroy(`api/DistributionLists/${id}`);
}

export const deleteDistributionListAlternative = async (id, distributionListAlternativeId) => {
    return await destroy(`api/DistributionLists/${id}/alternatives/${distributionListAlternativeId}`);
}